/**
 * Подпись ученика для кабинета преподавателя.
 * Своё имя (alias) важнее профиля; логин — запасной вариант.
 */
export function studentLabel(student) {
  if (!student) return '';
  const alias = (student.alias || '').trim();
  if (alias) return alias;
  const profile = [student.last_name, student.first_name].filter(Boolean).join(' ').trim();
  if (profile) return profile;
  return (student.display_name || student.username || '').trim();
}

/** «Петя @darklord99» или просто «Петя», если логин совпадает с подписью. */
export function studentLabelWithLogin(student) {
  const label = studentLabel(student);
  const username = (student?.username || '').trim();
  if (!username) return label;
  if (!label || label === username) return `@${username}`;
  return `${label} @${username}`;
}
